export const programsList = getters => {
  return getters.programsList
}

export const getManagingProgram = getters => {
  return getters.manageProgram
}
